import {
  bracketGameNumbers,
  bracketLevelConversion,
  bracketLevels,
  bracketTypeConversion,
} from "../routes/tournament/bracket/constants";

const generateGameNumbers = (bracket, bracketType, games) => {
  if (!bracket || !games || !bracketType || !bracketLevels) {
    return;
  }

  const gameNumbers = {};

  let numberOfByes = 0;

  for (
    let round = 0;
    round < Object.keys(bracket["upper"]).length + 2;
    round++
  ) {
    for (const bracketLevel of bracketLevels) {
      if (!bracket[bracketLevel]) {
        continue;
      }

      if (bracketLevel === "hayesUpper") {
        numberOfByes = 0;
      }

      const bracketSize = Object.keys(bracket[bracketLevel][0]).length;

      const gameIdsInRound = bracket[bracketLevel][round];

      const level = bracketLevelConversion[bracketLevel];
      const type = bracketTypeConversion[bracketType];
      const numberMap = bracketGameNumbers[level][type][bracketSize];

      if (!numberMap || !gameIdsInRound) {
        continue;
      }

      let numberOfByesInRound = 0;

      const isSecondLowerRound =
        round === 1 &&
        (bracketLevel === "lower" || bracketLevel === "hayesLower");

      if (isSecondLowerRound) {
        numberOfByesInRound = gameIdsInRound.filter(
          (gameId) =>
            games[gameId]?.team1Id === "BYE" || games[gameId]?.team2Id === "BYE"
        ).length;
      }

      for (let index = 0; index < gameIdsInRound.length; index++) {
        const gameId = gameIdsInRound[index];

        if (!gameId) {
          continue;
        }

        if (
          games[gameId]?.team1Id === "BYE" ||
          games[gameId]?.team2Id === "BYE"
        ) {
          gameNumbers[gameId] = null;

          numberOfByes++;
          numberOfByesInRound -= 2;
        } else if (isSecondLowerRound) {
          gameNumbers[gameId] =
            numberMap[round][index] - numberOfByes - numberOfByesInRound;
        } else {
          gameNumbers[gameId] = numberMap[round][index] - numberOfByes;
        }
      }
    }
  }

  return gameNumbers;
};

export default generateGameNumbers;
